import { Outlet } from "react-router";
import { StorefrontViewProvider } from "./StorefrontViewContext";

export const StorefrontViewLayout = () => (
  <StorefrontViewProvider>
    <Outlet />
  </StorefrontViewProvider>
);
